import get from 'lodash/get'

export function resolve(waColor) {
  return {
    icon: ``,
    cardColor: `${waColor}`
  }
}

export function colors({ plan, subscription, determinations }) {
  let val = 'info'

  const { isBacker, ended } = determinations
  const sku = get(plan, ['sku']) || get(subscription, ['plan', 'sku'])

  if (sku === 'FA-FREE') {
    val = 'info'
  }

  if (['FA-STANDARD', 'FA-BACKER', 'FA-MAX', 'FA-LITE', 'PRO1Y-STANDARD', 'PRO1Y-STUDENT'].indexOf(sku) > -1) {
    val = 'yellow'
  }

  if (['FA-STANDARD-PLUS', 'FA-MAX-PLUS', 'FA-LITE-PLUS'].indexOf(sku) > -1) {
    val = 'teal'
  }

  if (!plan && isBacker) {
    val = 'yellow'
  }

  if (!plan && ['alerting', 'grace-period'].indexOf(determinations.preOrderBackerStage) > -1) {
    val = 'warning'
  }

  if (!plan && ['shutoff'].indexOf(determinations.preOrderBackerStage) > -1) {
    val = 'gray'
  }

  if (!plan && determinations.indication === 'warning') {
    val = 'warning'
  }

  if (!plan && determinations.indication === 'danger') {
    val = 'danger'
  }

  if (!plan && determinations.ended) {
    val = 'gray'
  }

  // pro cancelled
  if (get(plan, ['active']) && ended) {
    val = 'gray'
  }

  return val
}
